import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class BusinessCategoryStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'BusinessCategoryStore',
			properties: [				
				'businessCategory',				
			],
		});
	}

	businessCategory = [];
	
	reset = () => {		
		this.businessCategory = [];	
	};	

	setBusinessCategory = async data => {
		runInAction(() => {
			this.businessCategory = data;
		});
	};
}